import {PageView} from "./PageView.js";
import {Header} from "../components/Header.js";
import {CompanyNameInput} from "../components/input/CompanyNameInput.js";
import {CompanyCategorySelect} from "../components/select/CompanyCategorySelect.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {HopeUserCountSelect} from "../components/select/HopeUserCountSelect.js";
import {CompanyProfileLayout} from "../components/layout/CompanyProfileLayout.js";
import {addCompanyCategory, addCompanyName, addCompanySubDomain, addHopeCount, getUser, isSnsSignUp} from "../store.js";
import {DEFAULT_SUB_DOMAIN, ERROR_CODE} from "../constant.js";
import {InputValidator} from "../util/input-validate/inputValidation.js";
import {LoadingPopup} from "../components/popup/LoadingPopup.js";


export class CompanyProfileView extends PageView {

    renderLayout() {
        const {mainText = '', subText = ''} = this.$props;
        new CompanyProfileLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText,
            nextButton: {
                text: `${i18next.t(login.registerComplete)}`,
                nextPageFunc: this.createCompany.bind(this)
            } ,
            nextLink : {
                text : i18next.t(login.alreadyInUse),
                nextPageFunc: () => {
                    SignUpViewChanger.loadSearchCompanyBySubDomain();
                }
            }
        });
    }


    getSectionId() {
        return `companyInfoInputSection`
    }

    renderComponents() {
        const $section = $(`#${this.getSectionId()}`);
        new Header($section.find(".js-section-header"), {
            isShowLoginBtn: false,
            isShowPrevBtn: true
        });
        this.$props.CompanyNameInput = new CompanyNameInput($("#companyNameLayer"), {
            isLast: Often.isGlobal(),
            addClassName: this.getCommonJoinInputClassName(),
            submit : this.createCompany.bind(this)
        });

        this.$props.CompanyCategorySelect = !Often.isGlobal() ? new CompanyCategorySelect($("#companyCategorySelectLayer"), {
            addClassName: this.getCommonJoinInputClassName()
        }) : null;

        this.$props.HopeUserCountSelect = !Often.isGlobal() ? new HopeUserCountSelect($("#hopeCountSelectLayer"), {
            addClassName: this.getCommonJoinInputClassName()
        }): null;

    }

    addCompanyInfo() {
        addCompanyName(this.$props.CompanyNameInput.getInputValue());
        addCompanySubDomain(this.getSubDomain());
        if(this.$props.CompanyCategorySelect !== null) {
            addCompanyCategory(this.$props.CompanyCategorySelect.getSelectValue());
        }

        if( this.$props.HopeUserCountSelect !== null ) {
            addHopeCount(this.$props.HopeUserCountSelect.getSelectValue())
        }
    }

    getSubDomain() {
        const companyName = this.$props?.CompanyNameInput?.getInputValue();
        if (Mutil.empty(companyName)) {
            return;
        }
        const isValidCompanyUrl = InputValidator.isValidTeamUrl(companyName);
        return isValidCompanyUrl ? companyName : DEFAULT_SUB_DOMAIN;
    }
    getCommonJoinInputClassName() {
        return `js-join-input`
    }
    async createCompany() {
        const $section = $(`#${this.getSectionId()}`);
        const $Inputs = $section.find(`.${this.getCommonJoinInputClassName()}`);
        if (!InputValidator.inputsValidate($Inputs)) {
            return;
        }

        const loadingPopup = new LoadingPopup($section.find("article"), {
            isAppend: true,
            loadingText : i18next.t(login.createWorkSpace)
        });

        this.addCompanyInfo();
        const {ERR_CD = '', PASS_JSON = {}, COMPANY_INFO_JSON = {}} = await getUser().createNewCompany();
        if (ERR_CD === ERROR_CODE.EXIST_SUB_DOMAIN) {
            Mutil.mlog("서브도메인이 존재합니다.");
            loadingPopup.removePopup();
            return;
        }

        if (ERR_CD === ERROR_CODE.EXIST_COMPANY) {
            Mutil.mlog("이미 회사가 존재합니다.");
            loadingPopup.removePopup();
            return;
        }

        const CommonLogin = Mutil.requireIIFE("CommonLogin");
        CommonLogin.goLogin({...PASS_JSON}, () => {
            loadingPopup.removePopup();
            SignUpViewChanger.loadInviteUserView({...COMPANY_INFO_JSON ,  isSignUpBySnS : isSnsSignUp() });
        });
    }
}